<template>
  <div class="resume-view-page__navs">
    <router-link-modified
      v-if="prevResume"
      type="button"
      class="resume-view-page__navs-btn base-btn base-btn--outline-grey _prev"
      :to="{
        name: 'received-resume',
        params: { resumeId: prevResume.sent_resume_id }
      }"
    >
      <BaseSvg
        name="ico-arrow-light"
        width=".4rem"
        height=".6rem"
      />

      <template v-if="windowSizeMixin.width > 767">
        <img v-if="prevResume[3].photos && prevResume[3].photos.length"
             :src="prevResume[3].photos[0].path"
             :alt="prevResume[3].photos[0].name">
        <div v-else class="resume-view-page__navs-btn-photo-placeholder">
          {{getPhotoTextPlaceholder($get(prevResume.parsed_questionaire_data.first_block, 'items'))}}
        </div>

        <span
          v-if="prevResume &&  
          prevResume.parsed_questionaire_data && 
          prevResume.parsed_questionaire_data.first_block && 
          prevResume.parsed_questionaire_data.first_block.items &&
          prevResume.parsed_questionaire_data.first_block.items.length"
          class="base-btn__text"
        >
          {{ $get(prevResume.parsed_questionaire_data.first_block, 'items[0].answer') }} {{ $get(prevResume.parsed_questionaire_data.first_block, 'items[1].answer') }}
        </span>

        <span
          v-else
          class="base-btn__text"
        >
          {{ $tResumeCard('Previous resume') }}
        </span>
      </template>

      <span
        v-else
        class="base-btn__text"
      >
        {{ $tResumeCard('Previous') }}
      </span>
    </router-link-modified>

    <router-link-modified
      v-if="nextResume"
      type="button"
      class="resume-view-page__navs-btn base-btn base-btn--outline-grey _next"
      :to="{
        name: 'received-resume',
        params: { resumeId: nextResume.sent_resume_id }
      }"
    >
      <template v-if="windowSizeMixin.width > 767">
        <span
          v-if="nextResume &&  
          nextResume.parsed_questionaire_data && 
          nextResume.parsed_questionaire_data.first_block && 
          nextResume.parsed_questionaire_data.first_block.items &&
          nextResume.parsed_questionaire_data.first_block.items.length"
          class="base-btn__text"
        >
          {{ $get(nextResume.parsed_questionaire_data.first_block, 'items[0].answer') }} {{ $get(nextResume.parsed_questionaire_data.first_block, 'items[1].answer') }}
        </span>

        <span
          v-else
          class="base-btn__text"
        >
          {{ $tResumeCard('Next summary') }}
        </span>

        <img v-if="nextResume[3].photos && nextResume[3].photos.length"
             :src="nextResume[3].photos[0].path"
             :alt="nextResume[3].photos[0].name">
        <div v-else class="resume-view-page__navs-btn-photo-placeholder">
          {{getPhotoTextPlaceholder($get(nextResume.parsed_questionaire_data.first_block, 'items'))}}
        </div>
      </template>

      <span
        v-else
        class="base-btn__text"
      >
        {{ $tResumeCard('Next') }}
      </span>

      <BaseSvg
        name="ico-arrow-light"
        width=".4rem"
        height=".6rem"
      />
    </router-link-modified>
  </div>
</template>

<script>
  import windowSizeMixin from '@/mixins/windowSizeMixin';

  export default {
    name: 'ResumeCardNavigation',
    mixins: [windowSizeMixin],

    props: {
      nextResume: Object,
      prevResume: Object
    },
    methods: {
      getPhotoTextPlaceholder(resume) {
        const name = resume[1].answer || ''
        const surname =  resume[0].answer || ''
        return ( surname.slice(0, 1) + name.slice(0, 1) ).toUpperCase()
      }
    }
  };
</script>
